import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Link } from 'react-router-dom';
import { GridList, GridTile } from 'material-ui/GridList';
import '../styles/GridList.css';
import './CategoriesList.css';

export default class LocationsList extends Component {

  renderLocation = (item) => {
    const { project } = this.props;

    return (
      <Link
        key={`location-${item.location.id}`}
        to={{
          pathname: `/dashboard/location/${project.id}/${item.location.id}`,
          state: { data: item, project }
        }}
      >
        <GridTile>
          <div className="category-symbol">
            <span className="circle">
              <span className="text">
                {/* {item.location.symbol} */}
              </span>
            </span>
          </div>
          <div className="category-title">
            {item.location.title}
          </div>
        </GridTile>
      </Link>
    );
  };

  render() {
    const { locations } = this.props;

    return (
      <Row start="xs" top="xs" className="categories-list grid-list-container">
        <Col xs={12}>
          <GridList className="grid-list" padding={10}>
            {locations.map(this.renderLocation)}
          </GridList>
        </Col>
      </Row>
    );
  }

};

